import styled from 'styled-components';
import { green } from '../../styles/constants';

const Checkbox = styled.span`
  height: 12px;
  width: 12px;
  background-color: ${(props) => (props.checked ? green : 'transparent')};
  display: inline-block;
  border: 2px solid ${green};
`;

export default Checkbox;
